// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import * as echarts from 'echarts'
import scroll from 'vue-seamless-scroll'
// import Video from 'video.js'




Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(scroll);
Vue.use(ElementUI);


const isTest = false    // false 线上

if(isTest){ // 发起共享信息,共享信息客户端的二级ID
  Vue.prototype.$Pane = {
    leftPane:{
      id:'devBin-left',
      send:"right"
    },
    rightPane:{
      id:'devBin-right',
      send:"left"
    }
  }
}else{
  Vue.prototype.$Pane = {
    leftPane:{
      id:'ddx-left',
      send:"right"
    },
    rightPane:{
      id:'ddx-right',
      send:"left"
    }
  }
}



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js